<template>
    <a-tooltip
        v-if="closestPoints && dataCenters.closestPoints"
        :text="closestPointsTooltip"
        class="closest-dc-points-tooltip"
    >
        <a-button
            class="closest-dc-points-button"
            :glyph="dataCenters.closestPoints.glyph || 'data-center'"
            :to="dataCenters.closestPoints.to || '/data-center/'"
            :target="dataCenters.closestPoints.target || '_blank'"
            :layout="dataCenters.closestPoints.layout || 'only-icon'"
        />
    </a-tooltip>
</template>

<script>
import { mapState } from 'vuex';
import AButton from '@core/components/button/button.vue';
import ATooltip from '@core/components/tooltip/tooltip.vue';

export default {
    name: 'ClosestPointsTooltip',
    components: {
        ATooltip,
        AButton,
    },
    computed: {
        ...mapState({
            location: (state) => state.geolocation?.location || null,
        }),

        country() {
            return this.location?.data?.country?.code;
        },

        dataCenters() {
            return this.$store.state.slices.items['s-data-centers'] || {};
        },

        closestPoints() {
            if (!this.dataCenters?.closestPoints) return false;
            const closestPoints = this.dataCenters.closestPoints.points[this.country] || false;
            return closestPoints ? closestPoints.join('<br />') : false;
        },

        closestPointsTooltip() {
            if (!this.closestPoints) return false;

            return `
                <div style="text-align: center;">
                    <div class="a-mb-1">${this.dataCenters.closestPoints.title}</div>
                    <div>${this.closestPoints}</div>
                </div>
            `;
        },
    },
};
</script>

<style scoped lang="postcss">
.closest-dc-points-tooltip {
    .closest-dc-points-button {
        background: var(--av-fixed-success-accent);
        color: var(--av-fixed-success-dark);
        border: none;
        outline: none;
        &:hover,
        &:active,
        &:focus {
            background: var(--av-fixed-success-light);
            color: var(--av-fixed-success-dark);
        }
        &:deep(.a-button__glyph) {
            margin: 0 !important;
            fill: var(--av-fixed-success-dark) !important;
        }
    }
}
</style>
